/* eslint-disable @typescript-eslint/no-explicit-any */
import { Image, Input, Typography } from 'beek-design-system';
import { useEffect, useState } from 'react';
import { useTranslations } from 'next-intl';
import Const from 'src/config/Const';
import dynamic from 'next/dynamic';
import styled from 'styled-components';

const BackgraundContainer = styled.div`
  width: 100%;
  background-color: var(--snow-blue);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 1.5rem 1rem 2rem 1rem;
  margin-bottom: 0;
  @media ${({ theme }): string => theme.devices.laptop} {
    height: 37.25rem;
    padding: 0;
  }
`;

const InputContainer = styled.div`
  width: 90%;
  max-width: 922px;
`;

const TitleContainer = styled(Typography)`
  margin-bottom: 1.5rem;
  text-align: center;
  @media ${({ theme }): string => theme.devices.laptop} {
    margin-bottom: 2rem;
    width: 32.938rem;
  }
`;

const ImageContainer = styled.div`
  margin-top: 2rem;
  @media ${({ theme }): string => theme.devices.laptop} {
    margin-top: 4rem;
  }
`;

const CatalogueSection = (): JSX.Element => {
  const t = useTranslations('landing');
  const [isSearchClicked, setIsSearchClicked] = useState(false);

  const DynamicInput: any = dynamic(
    (): any => import('../../Common/Algolia/AlgoliaInput'),
    {
      ssr: false,
      loading: () => (
        <Input
          placeholder={`${t('catalogue.placeholderCopy')}`}
          onClickInput={(): void => setIsSearchClicked(!isSearchClicked)}
          icon="search"
          background="white"
          landing
          colorPlaceholder="gray50"
        />
      ),
    }
  );

  useEffect(() => {
    setIsSearchClicked(true);
  }, []);

  return (
    <BackgraundContainer>
      <TitleContainer type="headline2">{`${t(
        'catalogue.title'
      )}`}</TitleContainer>
      <InputContainer>
        {!isSearchClicked ? (
          <Input
            placeholder={`${t('catalogue.placeholderCopy')}`}
            icon="search"
            background="white"
            landing
            colorPlaceholder="gray50"
          />
        ) : (
          <DynamicInput
            type="landing"
            placeholder={`${t('catalogue.placeholderCopy')}`}
            background="white"
            landing
            colorPlaceholder="gray50"
            noResultsText={`${t('catalogue.noResults')}`}
          />
        )}
      </InputContainer>
      <ImageContainer>
        <Image
          url={`${Const.cdnUrl}/landing_page/mobile/audiobook-covers-landing-mobile.png`}
          laptopUrl={`${Const.cdnUrl}/landing_page/desktop/audiobook-covers-landing.png`}
          type="covers_grid"
          alt={`${t('catalogue.alt')}`}
        />
      </ImageContainer>
    </BackgraundContainer>
  );
};
export default CatalogueSection;
